export const ActionTypes = 
{
    SET_RESULT: "SET_RESULT",
    SET_TOBE_FILTERED: "SET_TOBE_FILTERED",
    SET_REPORT_FILTER: "SET_REPORT_FILTER",
    SET_DATE_RANGE: "SET_DATE_RANGE",
    RESET: "RESET",
}